import useApi, { Api, Model, Query } from "../common/hooks/useApi"
import { Equipo } from "../equipos/useEquiposAPI"

export type TipoConfiguracionAnalitica = 'CRUCE_SEMAFORO' | 'INVASION_SENDA' | 'ESTADISTICA_CRUCE_SEMAFORO'

export interface LuzSemaforo {
    Etiqueta: string
    Posicion: number[][]
    EncendidoRequerido: boolean
}

export interface ConfiguracionAnalitica extends Model {
    Etiqueta?:string,
    Equipo?: Equipo
    Tipo: TipoConfiguracionAnalitica
    FormatoFechaHora?: string
    Areas: string, //{ [key: string]: number[][][] }
    ClasesPermitidas: string //{ Nombre: string }[]
    Imagen?: { FullUrl: string }
    CriterioSemaforo?: string
    /*
    PosicionFechaHora?:number[]
    Semaforo?:LuzSemaforo[]
    AreasLPR:number[][][]
    ClasesPermitidas:string[]

    // Cruce semaforo
    AreasPreviasCruce?:number[][][]
    AreasPosterioresCruce?:number[][][]

    // Invasión senda
    AreaSendaPeatonal?:number[][]*/
}

export interface ConfiguracionAnaliticaForm extends Omit<Partial<ConfiguracionAnalitica>, 'CriterioSemaforo' | 'Areas' | 'ClasesPermitidas' | 'Equipo'> {
    EquipoId?: number
    UnidadProduccionId?: number
    Areas?: { [key: string]: number[][][] }
    ClasesPermitidas?: { Nombre: string }[]
    CriterioSemaforo?: { [key: string]: boolean }

}

export interface ConfiguracionAnaliticaSave extends Omit<Partial<ConfiguracionAnalitica>, 'Equipo'> {
    Areas: string
    ClasesPermitidas: string
    EquipoId?: number
    ImagenUpload?: File
}


export default () => {
    const api = useApi({ module: "ConfiguracionAnalitica" });

    return {
        list: (query: Query) => api.list!<ConfiguracionAnalitica>(query),
        save: (data: ConfiguracionAnaliticaSave) => {
            return api.save!<ConfiguracionAnaliticaSave, ConfiguracionAnalitica>(data, true, api.getFormData);
        },
        delete: (id: number) => api.delete!<ConfiguracionAnalitica>(id)
    };
}